import contentConstants from '../contentConstants';
import { ISurveyEditModel } from '../models';
import * as SurveyAPI from '../services/SurveyAPI';
import { ActionTypes } from './ActionTypes';

export interface IPreviewProps {
	surveyId: number;
	surveyEditModel: ISurveyEditModel;
}

export const SurveyPreviewActionCreators = {
	PublishPreview: (surveyId: number) => (dispatch: any) => {
		dispatch({ type: ActionTypes.TOAST_PROCESSING_GENERIC_NOTIFICATION });
		dispatch({ type: ActionTypes.SURVEY_PUBLISH_REQUESTED });

		return SurveyAPI.publishSurvey(surveyId, true)
			.then((result: any) => {
				dispatch({ type: ActionTypes.TOAST_SUCCESS_GENERIC_NOTIFICATION });
				dispatch({ type: ActionTypes.SURVEY_PUBLISH_PREVIEW_SUCCEEDED });
				openPreviewWindow(result.PreviewUrl);
			})
			.catch(() => {
				dispatch({
					type: ActionTypes.TOAST_WARNING_CUSTOM_NOTIFICATION,
					payload: {
						message: contentConstants.TOAST_ERROR_PUBLISH_FAILURE_BODY,
						messageTitle: contentConstants.TOAST_ERROR_PUBLISH_FAILURE_TITLE,
					},
				});
				dispatch({ type: ActionTypes.SURVEY_PUBLISH_FAILED });
			});
	},
	PreviewSurvey: (previewUrl: string) => (dispatch: any) => {
		openPreviewWindow(previewUrl);
		// Without a dispatch, PreviewSurvey results in a undefined type error from redux-oidc.
		dispatch({ type: ActionTypes.SURVEY_PREVIEW_COMPLETED });
	},
	GetPreviewModel: (surveyId: number) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SURVEY_PREVIEW_GET_REQUESTED });
		return SurveyAPI.getSurveyPreviewModel(surveyId).then((result: any) => {
			dispatch({ type: ActionTypes.SURVEY_PREVIEW_GET_SUCCEEDED, payload: result });
		});
	},
};

function openPreviewWindow(url: string) {
	if (url) {
		window.open(url, '_blank');
	}
}
